var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"label":_vm.label}},[_c('config-color-picker',{attrs:{"mOptions":_vm.mOptions,"width":_vm.width},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }